var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.497,
    height: 36.743,
    viewBox: "0 0 34.497 36.743",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stampa",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_158",
    "data-name": "Raggruppa 158",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_225",
    "data-name": "Rettangolo 225",
    width: 20.284,
    height: 6.878,
    transform: "translate(6.106)",
    fill: "none",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_997",
    "data-name": "Tracciato 997",
    d: "M63.285,56.1H61.706A4.111,4.111,0,0,1,57.6,52V40.206A4.111,4.111,0,0,1,61.706,36.1H85.991A4.111,4.111,0,0,1,90.1,40.206V51.962a4.111,4.111,0,0,1-4.106,4.106h-1.86",
    transform: "translate(-57.6 -29.222)",
    fill: "none",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_219",
    "data-name": "Linea 219",
    x2: 25.794,
    transform: "translate(3.369 22.144)",
    fill: "none",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_220",
    "data-name": "Linea 220",
    x2: 14.634,
    transform: "translate(8.949 25.197)",
    fill: "none",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_221",
    "data-name": "Linea 221",
    x2: 14.634,
    transform: "translate(8.949 28.461)",
    fill: "none",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_226",
    "data-name": "Rettangolo 226",
    width: 20.46,
    height: 12.599,
    transform: "translate(6.036 22.144)",
    fill: "none",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_65",
    "data-name": "Ellisse 65",
    cx: 2.468,
    cy: 2.468,
    r: 2.468,
    transform: "translate(23.771 10.353)",
    fill: "#ed1c24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionPrintIcon);
export default __webpack_public_path__ + "static/media/action-print-icon.1ca55bd02e1f8b5ef2ff47e66e3f9dbc.svg";
export { ForwardRef as ReactComponent };